import script from "./ModalCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCustom.vue?vue&type=script&setup=true&lang=js"

import "./ModalCustom.vue?vue&type=style&index=0&id=411dc370&lang=css"

const __exports__ = script;

export default __exports__